"use client";

import CartIcon from "../icons/CartIcon";
import { useCart } from "../contexts/CartContext";
import { Button } from "@/components";

export default function CartButton() {
  const { state, openCart } = useCart();
  const itemCount = state.items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <Button
      type="button"
      onClick={openCart}
      size="icon-md"
      variant="icon"
      color="white"
      className="relative rounded-lg"
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <CartIcon size={24} color="currentColor" />
      {itemCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-green-50 text-constant-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {itemCount > 9 ? "9+" : itemCount}
        </span>
      )}
    </Button>
  );
}
